import { useNavigate, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import menuItem from 'menu-items';
import { useGetMenuMaster } from 'api/menu';
// import { useAuth } from 'contexts/AuthContext'; // TODO: enable for production

function buildMenuItems(items) {
  return items.map((item) => {
    if (item.type === 'group') {
      const children = buildMenuItems(item.children || []);
      if (!children.length) return null;
      return { type: 'group', key: item.id, label: item.title, children };
    }
    if (item.type === 'collapse') {
      const Icon = item.icon;
      const children = buildMenuItems(item.children || []);
      return { key: item.id, icon: Icon ? <Icon /> : null, label: item.title, children };
    }
    if (item.type === 'item') {
      const Icon = item.icon;
      return { key: item.url, icon: Icon ? <Icon /> : null, label: item.title };
    }
    return null;
  }).filter(Boolean);
}

export default function Navigation() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  const items = buildMenuItems(menuItem.items);

  return (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[pathname]}
      inlineCollapsed={!drawerOpen}
      items={items}
      onClick={({ key }) => {
        if (key.startsWith('http')) window.open(key, '_blank');
        else navigate(key);
      }}
      style={{ border: 'none', paddingTop: 8 }}
    />
  );
}
